/**
 * Load in the correct css for the vendor
 *
 * @ignore
 */
const loadStyles = vendor => {
  const brands = ['sg', 'nlo', 'nzrb', 'bclc', 'ds', 'czr', 'gn', "bfc", "wc", "hrc"];
  const publicUrl = process.env.PUBLIC_URL;
  if (publicUrl != null) {
    const headID = document.getElementsByTagName("head")[0];
    if (vendor != null) {
      let url = null;
      if (brands.includes(vendor.toLowerCase())) {
        url = `${publicUrl}/static/css/${vendor.toLowerCase()}.css?v=${process.env.VERSION}`;
      }
      if (url !== null) {
        if (document.getElementById("com.r7.bb-style") !== null) {
          document.getElementById("com.r7.bb-style").outerHTML = "";
        }
        let link = document.createElement("link");
        link.setAttribute("id", "com.r7.bb-style");
        link.setAttribute("rel", "stylesheet");
        link.setAttribute("type", "text/css");
        link.setAttribute("href", url);
        headID.appendChild(link);
      }
    }
  }
};

export default loadStyles;



// WEBPACK FOOTER //
// ./src/styleLoader/index.js